import React from 'react'
import Joyride, { ACTIONS, EVENTS } from 'react-joyride'
import * as CustomStyles from '../styles/CustomStyles'
import { connect } from 'react-redux'
import { submitWalkthrough } from '../../../store/ui/actions'
import { getHasWalkthrough } from '../../../store/login/reducers'
import { fetchHasWalkthrough } from '../../../store/login/actions'
import Translation from '../../global/Translation'

const mapStateToProps = (state) => {
    return {
        hasWalkthrough: getHasWalkthrough(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSubmitWalkthrough: (type, noShowMore) => dispatch(submitWalkthrough(type, noShowMore)),
        refreshData: () => dispatch(fetchHasWalkthrough())
    }
}

class OrderDetailsWalkthrough extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            stepIndex: 0,
            type: 'ORDER_DETAILS'
        }
    }

    /**
     *  Body content for step one
     */
    stepOneContent = () => {
        return (
            <div className="walkthrough__tooltip__content__main">
                <div className="walkthrough__tooltip__content__main--heading">
                    <h2><Translation id="walkthrough_view_in_detail_all_the_information_of_your_order" defaultMessage="View in detail all the information of your order" /></h2>
                </div>
                <div className="walkthrough__tooltip__content__main--info">
                    <span><Translation id="walkthrough_order_number_address_quality" defaultMessage="Order number, address, quantity of products, your comments etc..." /></span>
                </div>
            </div>
        )
    }

    /**
     * Body content for step two
     */
    stepTwoContent = () => {
        return (
            <div className="walkthrough__tooltip__content">
                <div className="walkthrough__tooltip__content--heading">
                    <h2><Translation id="delivery_information" defaultMessage="Delivery information" /></h2>
                </div>
                <div className="walkthrough__tooltip__content--info">
                    <span><Translation id="walkthrough_here_you_can_check_the_status_of_your_product" defaultMessage="Here you can check the status of your product, its delivery date and you can even access the shipment details." /></span>
                </div>
            </div>
        )
    }

    /**
     * Body content for step three
     */
    stepThreeContent = () => {
        return (
            <div className="walkthrough__tooltip__content">
                <div className="walkthrough__tooltip__content--heading">
                    <h2><Translation id="the_content_of_your_order" defaultMessage="The content of your order" /></h2>
                </div>
                <div className="walkthrough__tooltip__content--info">
                    <span><Translation id="walkthrough_viw_the_content_of_your_order_at_any_time" defaultMessage="View the content of your order at any time. You will also be able to modify it if you do not have any delivery planned yet." /></span>
                </div>
            </div>
        )
    }

    /**
     * Determines which step content to display
     * @returns boolean
     */
    breakpointIndicator = () => {
        if (window.innerWidth <= 767) return true
        return false
    }
    
    // Desktop version
    stepTwoDesktop = {
        content: this.stepTwoContent(),
        locale: {
            next: <span aria-label="next"><Translation id="next" defaultMessage="Next" /></span>,
            back: <span aria-label="back"><Translation id="back" defaultMessage="Back" /></span>
        },
        target: '.td-delivery-info',
        styles: {
            buttonSkip: {
                display: 'none'
            }
        }
    }

    // Responsive version
    stepTwoResponsive = {
        content: this.stepTwoContent(),
        locale: {
            next: <span aria-label="next"><Translation id="next" defaultMessage="Next" /></span>,
            back: <span aria-label="back"><Translation id="back" defaultMessage="Back" /></span>
        },
        target: '.order__shipping__details__table--shippings',
        styles: {
            buttonSkip: {
                display: 'none'
            }
        }
    }

    /**
     * steps
     */
    steps = {
        steps: [
            {
                content: this.stepOneContent(),
                locale: {
                    next: <span aria-label="next"><Translation id="get_started" defaultMessage="Get started" /></span>,
                    skip: <span aria-label="skip"><Translation id="do_not_show_again" defaultMessage="Do not show again" /></span>
                },
                target: '.order__shipping__details__boxresume',
            },
            this.breakpointIndicator() ? this.stepTwoResponsive : this.stepTwoDesktop,
            {
                content: this.stepThreeContent(),
                locale: {
                    last: <span aria-label="last"><Translation id="understood" defaultMessage="Understood" /></span>,
                    back: <span aria-label="back"></span>
                },
                target: '.order__shipping__details__table',
                styles: {
                    buttonSkip: {
                        display: 'none'
                    }
                }
            }
        ]
    }

    /**
     * Callback function to manipulate the walkthrough logic
     */
    handleJoyrideCallback = data => {
        const { action, index, type } = data

        const endStatus = [EVENTS.TOUR_END]

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) })
        }

        if (index === 0) {
            if (endStatus.includes(type)) {
                this.props.onSubmitWalkthrough(this.state.type, true).then(() => this.props.refreshData())
            }
        } else if (endStatus.includes(type)) {
            this.props.onSubmitWalkthrough(this.state.type, false).then(() => this.props.refreshData())
        }
    }

    getWalkthroughByType = walkthroughType => {
        const { hasWalkthrough } = this.props

        if (hasWalkthrough && hasWalkthrough.length > 0) {
            return hasWalkthrough.find(walkthrough => walkthrough.type === walkthroughType)
        }

        return null
    }

    shouldShowWalkthrough = walkthrough => {
        return walkthrough && walkthrough.shouldShow
    }

    render() {
        const { steps } = this.steps

        return this.shouldShowWalkthrough(this.getWalkthroughByType(this.state.type)) ? (
            <React.Fragment>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous
                    showProgress
                    steps={steps}
                    styles={{
                        tooltip: CustomStyles.TooltipStyles,
                        tooltipContent: CustomStyles.TooltipContentStyles,
                        options: CustomStyles.OptionStyles,
                        buttonNext: CustomStyles.ButtonNextStyles,
                        buttonBack: CustomStyles.ButtonBackStyles,
                        tooltipFooter: CustomStyles.TooltipFooterStyles,
                        spotlight: CustomStyles.SpotlightSyles
                    }}
                    disableScrolling
                    showSkipButton
                />
            </React.Fragment>
        ) : null
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailsWalkthrough)